type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      className={`relative overflow-hidden rounded-md bg-surface-raised ${className}`}
    >
      <div
        className="absolute inset-0 -translate-x-full animate-[skeleton-sweep_1.4s_ease-in-out_infinite]"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(34,255,95,0.05), transparent)",
        }}
      />
    </div>
  );
}
